export default "__VITE_ASSET__d54e1db3__"